export const diaprofilEnableWhenFunctions = {
  isWHO5ScoreBelow50: (formAnswers: { [key: string]: any }): boolean => {
    const scoreDict = {
      ALWAYS: 5,
      MOST_OF_THE_TIME: 4,
      MORE_THAN_HALF_THE_TIME: 3,
      LESS_THAN_HALF_THE_TIME: 2,
      SOMETIMES: 1,
      NEVER: 0,
      NO_ANSWER: 0
    };
    const overallScore = Object.keys(formAnswers).reduce((acc, key) => {
      if (
        [
          "feltHappy",
          "feltCalm",
          "feltActive",
          "feltFresh",
          "interestingDays"
        ].indexOf(key) > -1
      ) {
        const value = formAnswers[key];
        const itemScore = (scoreDict[value] || 0) * 4;
        return acc + itemScore;
      }
      return acc;
    }, 0);
    return overallScore < 50;
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/enable-when-functions.ts